import { useState } from "react";
import { useTheme, DARK, LIGHT } from "../../../components/Layout";
import Purchase    from "./Purchase";
import Sale        from "./Sale";
import PaymentIn   from "./PaymentIn";
import PaymentOut  from "./PaymentOut";
import Expense     from "./Expense";
import COGS        from "./COGS";
import Transfer    from "./Transfer";
import JournalReport from "./JournalReport";
import {
  ShoppingCart, TrendingUp, ArrowDownLeft,
  ArrowUpRight, ReceiptText, PackageCheck, ArrowLeftRight, FileBarChart,
} from "lucide-react";

type JTab = "purchase" | "sale" | "payment_in" | "payment_out" | "expense" | "cogs" | "transfer" | "report";

const TABS: { id: JTab; label: string; icon: any; color: string }[] = [
  { id: "purchase",    label: "خرید",               icon: ShoppingCart,   color: "#f59e0b" },
  { id: "sale",        label: "فروش",               icon: TrendingUp,     color: "#10b981" },
  { id: "payment_in",  label: "دریافت پول",          icon: ArrowDownLeft,  color: "#3b82f6" },
  { id: "payment_out", label: "پرداخت پول",          icon: ArrowUpRight,   color: "#f97316" },
  { id: "expense",     label: "ثبت مصارف",           icon: ReceiptText,    color: "#ef4444" },
  { id: "cogs",        label: "هزینه اجناس / COGS", icon: PackageCheck,   color: "#8b5cf6" },
  { id: "transfer",    label: "انتقال پول",           icon: ArrowLeftRight, color: "#06b6d4" },
  { id: "report",      label: "گزارش جورنال",        icon: FileBarChart,   color: "#a855f7" },
];

export default function JournalPage() {
  const { dark } = useTheme();
  const T = dark ? DARK : LIGHT;
  const [active, setActive] = useState<JTab>("purchase");

  return (
    <div style={{ fontFamily: "'Vazirmatn','Segoe UI',sans-serif" }}>
      <div style={{
        display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 24,
        padding: 8, borderRadius: 14,
        background: dark ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.02)",
        border: `1px solid ${T.cardBorder}`,
      }}>
        {TABS.map(tab => (
          <button key={tab.id} onClick={() => setActive(tab.id)} style={{
            display: "flex", alignItems: "center", gap: 6,
            padding: "9px 14px", borderRadius: 10, border: "none",
            cursor: "pointer", fontSize: 12, fontWeight: 700,
            fontFamily: "'Vazirmatn','Segoe UI',sans-serif",
            background: active === tab.id
              ? tab.id === "report"
                ? "linear-gradient(135deg,#a855f7,#7c3aed)"
                : `linear-gradient(135deg,${tab.color},${tab.color}bb)`
              : "transparent",
            color: active === tab.id ? "#fff" : T.subtext,
            transition: "all 0.2s",
            boxShadow: active === tab.id ? `0 3px 10px ${tab.color}40` : "none",
            position: "relative" as const,
          }}>
            <tab.icon size={14} />
            {tab.label}
            {tab.id === "report" && active !== "report" && (
              <span style={{
                position: "absolute", top: -4, left: -4,
                width: 8, height: 8, borderRadius: "50%",
                background: "#a855f7", boxShadow: "0 0 6px #a855f7",
              }} />
            )}
          </button>
        ))}
      </div>

      {active === "purchase"    && <Purchase />}
      {active === "sale"        && <Sale />}
      {active === "payment_in"  && <PaymentIn />}
      {active === "payment_out" && <PaymentOut />}
      {active === "expense"     && <Expense />}
      {active === "cogs"        && <COGS />}
      {active === "transfer"    && <Transfer />}
      {active === "report"      && <JournalReport />}
    </div>
  );
}
